import { store, getContext } from "@wordpress/interactivity";

const { state } = store("abr/image-gallery", {
    actions: {
        openModal() {
            document.body.classList.add( 'photo-gallery-open' );
            state.isModalOpen = true;
        },
        closeModal() {
            document.body.classList.remove( 'photo-gallery-open' );
            state.isModalOpen = false;
        },
    },
});